module.exports = "/matchcenter-staging/assets/images/epsilontv.f6e2e0669874d06e6a62aa7e94065a5e.png";